import { render, staticRenderFns } from "./MapDetails.vue?vue&type=template&id=88034f28&scoped=true&"
import script from "./MapDetails.vue?vue&type=script&lang=js&"
export * from "./MapDetails.vue?vue&type=script&lang=js&"
import style0 from "./MapDetails.vue?vue&type=style&index=0&id=88034f28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88034f28",
  null
  
)

export default component.exports